"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _Coordinate = _interopRequireDefault(require("../Coordinate"));

var _IllegalArgumentException = _interopRequireDefault(require("../../../../../java/lang/IllegalArgumentException"));

var _Double = _interopRequireDefault(require("../../../../../java/lang/Double"));

var _CoordinateSequence = _interopRequireDefault(require("../CoordinateSequence"));

var _Serializable = _interopRequireDefault(require("../../../../../java/io/Serializable"));

var _StringBuilder = _interopRequireDefault(require("../../../../../java/lang/StringBuilder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CoordinateArraySequence =
/*#__PURE__*/
function () {
  function CoordinateArraySequence() {
    _classCallCheck(this, CoordinateArraySequence);

    CoordinateArraySequence.constructor_.apply(this, arguments);
  }

  _createClass(CoordinateArraySequence, [{
    key: "setOrdinate",
    value: function setOrdinate(index, ordinateIndex, value) {
      switch (ordinateIndex) {
        case _CoordinateSequence.default.X:
          this._coordinates[index].x = value;
          break;

        case _CoordinateSequence.default.Y:
          this._coordinates[index].y = value;
          break;

        case _CoordinateSequence.default.Z:
          this._coordinates[index].z = value;
          break;

        default:
          throw new _IllegalArgumentException.default("invalid ordinateIndex");
      }
    }
  }, {
    key: "size",
    value: function size() {
      return this._coordinates.length;
    }
  }, {
    key: "getOrdinate",
    value: function getOrdinate(index, ordinateIndex) {
      switch (ordinateIndex) {
        case _CoordinateSequence.default.X:
          return this._coordinates[index].x;

        case _CoordinateSequence.default.Y:
          return this._coordinates[index].y;

        case _CoordinateSequence.default.Z:
          return this._coordinates[index].z;
      }

      return _Double.default.NaN;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (arguments.length === 1) {
        var i = arguments[0];
        return this._coordinates[i];
      } else if (arguments.length === 2) {
        var index = arguments[0],
            coord = arguments[1];
        coord.x = this._coordinates[index].x;
        coord.y = this._coordinates[index].y;
        coord.z = this._coordinates[index].z;
      }
    }
  }, {
    key: "getCoordinateCopy",
    value: function getCoordinateCopy(i) {
      return new _Coordinate.default(this._coordinates[i]);
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return this._dimension;
    }
  }, {
    key: "getX",
    value: function getX(index) {
      return this._coordinates[index].x;
    }
  }, {
    key: "expandEnvelope",
    value: function expandEnvelope(env) {
      for (var i = 0; i < this._coordinates.length; i++) {
        env.expandToInclude(this._coordinates[i]);
      }

      return env;
    }
  }, {
    key: "copy",
    value: function copy() {
      var cloneCoordinates = new Array(this.size()).fill(null);

      for (var i = 0; i < this._coordinates.length; i++) {
        cloneCoordinates[i] = this._coordinates[i].copy();
      }

      return new CoordinateArraySequence(cloneCoordinates, this._dimension);
    }
  }, {
    key: "toString",
    value: function toString() {
      if (this._coordinates.length > 0) {
        var strBuilder = new _StringBuilder.default(17 * this._coordinates.length);
        strBuilder.append('(');
        strBuilder.append(this._coordinates[0]);

        for (var i = 1; i < this._coordinates.length; i++) {
          strBuilder.append(", ");
          strBuilder.append(this._coordinates[i]);
        }

        strBuilder.append(')');
        return strBuilder.toString();
      } else {
        return "()";
      }
    }
  }, {
    key: "getY",
    value: function getY(index) {
      return this._coordinates[index].y;
    }
  }, {
    key: "toCoordinateArray",
    value: function toCoordinateArray() {
      return this._coordinates;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CoordinateArraySequence;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_CoordinateSequence.default, _Serializable.default];
    }
  }]);

  return CoordinateArraySequence;
}();

exports.default = CoordinateArraySequence;

CoordinateArraySequence.constructor_ = function () {
  this._dimension = 3;
  this._coordinates = null;

  if (arguments.length === 1) {
    if (arguments[0] instanceof Array) {
      var coordinates = arguments[0];
      CoordinateArraySequence.constructor_.call(this, coordinates, 3);
    } else if (Number.isInteger(arguments[0])) {
      var size = arguments[0];
      this._coordinates = new Array(size).fill(null);

      for (var i = 0; i < size; i++) {
        this._coordinates[i] = new _Coordinate.default();
      }
    } else if ((0, _hasInterface.default)(arguments[0], _CoordinateSequence.default)) {
      var coordSeq = arguments[0];

      if (coordSeq === null) {
        this._coordinates = new Array(0).fill(null);
        return null;
      }

      this._dimension = coordSeq.getDimension();
      this._coordinates = new Array(coordSeq.size()).fill(null);

      for (var i = 0; i < this._coordinates.length; i++) {
        this._coordinates[i] = coordSeq.getCoordinateCopy(i);
      }
    }
  } else if (arguments.length === 2) {
    if (arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
      var _coordinates = arguments[0],
          dimension = arguments[1];
      this._coordinates = _coordinates;
      this._dimension = dimension;
      if (_coordinates === null) this._coordinates = new Array(0).fill(null);
    } else if (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
      var _size = arguments[0],
          _dimension = arguments[1];
      this._coordinates = new Array(_size).fill(null);
      this._dimension = _dimension;

      for (var i = 0; i < _size; i++) {
        this._coordinates[i] = new _Coordinate.default();
      }
    }
  }
};

CoordinateArraySequence.serialVersionUID = -915438501601840650;